<template>
  <div class="eu-flex eu-justify_space-between emd-container__content">
    <div class="eu-flex-item eu-basis_12 eu-basis_5_lg">
      <CustomersDetailLink
        tabName="cards"
        :title="$t('charge.detail.payment-method.card.number')"
        :merchant-id="merchantId"
        :account-id="accountId"
        :customer-id="customerId"
      >
        {{ firstSixDigits }}
        {{ lastFourDigits }}
        <template #fallback>
          {{ firstSixDigits }}
          {{ lastFourDigits }}
        </template>
      </CustomersDetailLink>

      <PaymentCardsDetail
        :installments="installments"
        :exp-month="lastTransactionCard?.exp_month"
        :exp-year="lastTransactionCard?.exp_year"
      />
    </div>

    <div class="eu-flex-item eu-basis_12 eu-basis_5_lg">
      <CustomersDetailLink
        tabName="info"
        :title="$t('charge.detail.payment-method.card.name')"
        :merchant-id="merchantId"
        :account-id="accountId"
        :customer-id="customerId"
      >
        {{ holderName }}
        <template #fallback>
          {{ holderName }}
        </template>
      </CustomersDetailLink>

      <BillingAddres :billing-address="lastTransactionCard?.billing_address" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodPaymentCards',

  components: {
    CustomersDetailLink: () =>
      import('../../components/CustomersDetailLink.vue'),
    BillingAddres: () => import('./BillingAddres.vue'),
    PaymentCardsDetail: () => import('./PaymentCardsDetail.vue')
  },

  props: {
    lastTransactionId: { required: true },
    lastTransactionCard: { required: true },
    installments: { required: true },
    merchantId: { required: true },
    accountId: { required: true },
    customerId: { required: true }
  },

  computed: {
    firstSixDigits () {
      return (this.lastTransactionCard?.first_six_digits ?? '-') + '**'
    },
    lastFourDigits () {
      return '**' + (this.lastTransactionCard?.last_four_digits ?? '-')
    },
    holderName () {
      return this.lastTransactionCard?.holder_name ?? '-'
    }
  }
}
</script>
